// React:
import React from "react";
// Redux Toolkit Hooks:
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
// Redux Toolkit Actions & State:
import {
  directoryItems,
  directoryItemsRemoveInfoAction,
  directoryItemsTouchedAction,
} from "../../main/home/directory/directory-items/directoryItemsSlice";
import { deleteModalCloseAction, deleteModal } from "./deleteModalSlice";
import { deleteFolderAction } from "../../main/home/upload-and-create/create-folder/createFolderSlice";
import { deleteFileAction } from "../../main/home/upload-and-create/upload-file/uploadFileSlice";
import { drawerOpenOrCloseAction } from "../../main/home/drawer/drawerSlice";
import { deleteShareManagementListAction } from "../../main/share-management/shareManagementSlice";
// MUI Components:
import { Modal, Grid, Typography, Button, useTheme } from "@mui/material";
// MUI Styles:,
import { makeStyles } from "@mui/styles";
import { deleteUserManagementListAction } from "../../main/user-management/userManagementSlice";

const useStyles = makeStyles((theme) => ({
  backdropStyle: {
    "& .css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
      backdropFilter: "blur(2px)",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  },
  modalContainer: {
    backgroundColor: "rgba(255, 255, 255, 0.90)",
    color: theme.palette.text.secondary,
    borderRadius: "8px",
    "&:focus": {
      outline: "none",
    },
  },
}));

const DeleteModal = () => {
  const classes = useStyles();
  const theme = useTheme();

  const dispatch = useAppDispatch();

  const { openModal, actionPath, deleteId, type } = useAppSelector(deleteModal);

  const {
    itemInfo: { dir, name, path },
  } = useAppSelector(directoryItems);

  return (
    <Modal
      open={openModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      container={() => document.getElementById("modalContainer")}
      sx={{
        width: "100%",
        height: "100%",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1300,
        "&:focus": {
          outline: "none",
        },
        [theme.breakpoints.down("sm")]: {
          display: "none",
        },
      }}
      className={classes.backdropStyle}
    >
      <Grid
        container
        sx={{
          width: "450px",
          height: "240px",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: 12,
          p: "16px",
          "&:focus-visible": {
            outline: "none",
          },
          [theme.breakpoints.down("sm")]: {
            width: "80%",
          },
        }}
        className={classes.modalContainer}
      >
        <Grid
          item
          xs={12}
          sx={{
            width: "100%",
            height: "60%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: "8px",
          }}
        >
          <Typography
            sx={{
              textAlign: "center",
              fontSize: "26px",
              color: "inherit",
              [theme.breakpoints.down("sm")]: {
                fontSize: "22px",
              },
            }}
          >
            Are You Sure You Want To Delete Your {type}?
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{
            width: "100%",
            height: "40%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: "8px",
          }}
        >
          <Button
            variant="contained"
            color="tertiary"
            fullWidth
            type="submit"
            sx={{
              width: "110px",
              height: "40px",
              fontSize: "18px",
              borderRadius: "8px",
              textTransform: "none",
              lineHeight: "0px",
              padding: "12px",
              mr: "8px",
              color: "inherit",
              backgroundColor: "transparent",
              boxShadow: "none",
            }}
            onClick={() => dispatch(deleteModalCloseAction())}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="error"
            fullWidth
            type="submit"
            sx={{
              width: "110px",
              height: "40px",
              fontSize: "18px",
              borderRadius: "8px",
              textTransform: "none",
              lineHeight: "0px",
              padding: "12px",
            }}
            onClick={() => {
              switch (actionPath) {
                case "directory":
                  if (dir === true) {
                    dispatch(
                      deleteFolderAction({
                        path: path,
                        name: name,
                        id: deleteId,
                      })
                    );
                  } else {
                    dispatch(
                      deleteFileAction({
                        path: path,
                        name: name,
                        id: deleteId,
                      })
                    );
                  }
                  dispatch(deleteModalCloseAction());
                  dispatch(directoryItemsRemoveInfoAction());
                  dispatch(directoryItemsTouchedAction(false));
                  dispatch(drawerOpenOrCloseAction(false));
                  break;
                case "share-management":
                  dispatch(deleteShareManagementListAction({ id: deleteId }));
                  dispatch(deleteModalCloseAction());
                  break;
                case "user-management":
                  dispatch(deleteUserManagementListAction({ id: deleteId }));
                  dispatch(deleteModalCloseAction());
                  break;
                default:
                  break;
              }
            }}
          >
            Delete
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default DeleteModal;
